/**
 * 语言列头/badge 展示：优先 cr_language.NA_name（API linkCode），否则 BCP 语言子码。
 */

import { shortLangCode } from '@/modules/cr-v3-viewer/adapters/live-speech-adapter'

export interface LangDisplayInput {
  languageCode?: string
  languageName?: string
  languageEnName?: string
  /** cr_language.NA_name / API linkCode（如 zh、yue、en） */
  linkCode?: string
  shortCode?: string
}

/** 气泡简码：linkCode/shortCode 大写；无则 shortLangCode(BCP) 大写（zh-CN→ZH，en-US→EN） */
export function formatLangDisplayLabel(item: LangDisplayInput): string {
  const link = (item.linkCode ?? item.shortCode ?? '').trim()
  if (link) {
    return link.toUpperCase()
  }
  const short = shortLangCode(item.languageCode ?? '')
  if (short) {
    return short.toUpperCase()
  }
  return (item.languageCode ?? '').toUpperCase()
}
